import React from "react";
import { motion } from "framer-motion";
import SectionTitle from "./SectionTitle";
import { skills } from "../content/home";

const card = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] } }),
};

const Skills = () => {
  return (
    <section id="yetkinlikler" className="relative scroll-mt-24 py-24">
      <div className="mx-auto max-w-7xl container-px">
        <motion.div variants={card} initial="hidden" whileInView="show" viewport={{ once: true }} className="section-eyebrow mb-4">
          <span className="h-px w-8 bg-brand-500" /> {skills.eyebrow}
        </motion.div>

        <motion.div variants={card} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}>
          <SectionTitle lead={skills.title.lead} accent={skills.title.accent} tail={skills.title.tail} className="max-w-2xl" />
        </motion.div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {skills.groups.map((g, i) => (
            <motion.div
              key={g.label}
              variants={card}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className="glass-card group p-5 transition-colors hover:border-black/20 dark:hover:border-white/20"
            >
              <div className="mb-3 flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-gradient-to-r from-brand to-flame" />
                <h3 className="font-display text-sm font-semibold uppercase tracking-wider text-gray-800 dark:text-white/80">
                  {g.label}
                </h3>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {g.items.map((it) => (
                  <span key={it} className="chip">{it}</span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="relative mt-16 overflow-hidden border-y border-black/10 bg-black/[0.02] py-5 mask-fade-b dark:border-white/10 dark:bg-white/[0.02]">
        <div className="marquee-track flex w-max gap-10 whitespace-nowrap pr-10">
          {[...skills.marquee, ...skills.marquee].map((m, i) => (
            <span key={i} className="font-display text-2xl font-semibold text-gray-300 transition-colors hover:text-gray-700 dark:text-white/30 dark:hover:text-white/80">
              {m}
              <span className="ml-10 text-brand-500/40">/</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;